module.exports = __webpack_public_path__ + "static/shoe-green-95df884d9a1a28ca8fe711edd106c689.png";